const subscriptionsUrlMapper = {
  SP01_758_71_MOBIL: 'fri80gb',
  SP01_758_70_MOBIL: 'fri35gb',
  SP01_758_69_MOBIL: 'fri20gb',
  SP01_758_56_MOBIL: 'fri5gb',
  SP01_758_77_MOBIL: 'fri',
  SP01_758_64_MOBIL: '100gb',
  SP01_758_75_MOBIL: '80gb',
  SP01_758_62_MOBIL: '50gb',
  SP01_758_73_MOBIL: '40gb',
  SP01_758_60_MOBIL: '30gb',
  SP01_758_67_MOBIL: '20gb',
  SP01_758_79_MOBIL: 'borneabonnement'
};

const subscriptionsOldMapper = {
  SP01_758_38_MOBIL: 'fri',
  SP01_758_45_MOBIL: '80gb',
  SP01_758_58_MOBIL: '40gb',
  SP01_758_34_MOBIL: '25gb',
  SP01_758_67_MOBIL: '15gb',
  SP01_758_79_MOBIL: 'borneabonnement'
};
export const codeToName = (productCode: any) =>
  (productCode && subscriptionsUrlMapper[productCode]) || productCode;

export const nameToCode = (name: any) => {
  if (!name) return;
  const serviceFromName = Object.entries(subscriptionsUrlMapper).find(([, value]) => {
    return value === name;
  });
  const serviceFromOldName = Object.entries(subscriptionsOldMapper).find(([, value]) => {
    return value === name;
  });
  if (!serviceFromName && serviceFromOldName && serviceFromOldName[0]) {
    return serviceFromOldName[0];
  }

  return (serviceFromName && serviceFromName[0]) || name;
};
